export default __webpack_public_path__ + "static/media/logoBackground.135332ec.svg";